

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPDATEEMPLOYEEFROMEXCEL= createAsyncThunk(
  "bulkUpdateEmployeeFromExcel/bulkUpdateEmployeeFromExcel",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUpdateEmployeeFromExcelSlice = createSlice({
  name: "bulkUpdateEmployeeFromExcelSlice",
  initialState: {
    bulkUpdateEmployeeFromExcel: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUpdateEmployeeFromExcel: (state) => {
        state.bulkUpdateEmployeeFromExcel.loading = false
        state.bulkUpdateEmployeeFromExcel.error = false
        state.bulkUpdateEmployeeFromExcel.data = []
        state.bulkUpdateEmployeeFromExcel.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPDATEEMPLOYEEFROMEXCEL.fulfilled, (state, action) => {
      state.bulkUpdateEmployeeFromExcel = {
        ...state.bulkUpdateEmployeeFromExcel,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPDATEEMPLOYEEFROMEXCEL.pending, (state, action) => {
      state.bulkUpdateEmployeeFromExcel = {
        ...state.bulkUpdateEmployeeFromExcel,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPDATEEMPLOYEEFROMEXCEL.rejected, (state, action) => {
      state.bulkUpdateEmployeeFromExcel = {
        ...state.bulkUpdateEmployeeFromExcel,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUpdateEmployeeFromExcelAction = {
    BULKUPDATEEMPLOYEEFROMEXCEL,
};

export { bulkUpdateEmployeeFromExcelAction };
export default bulkUpdateEmployeeFromExcelSlice.reducer;
export const {setInitialStateOfbulkUpdateEmployeeFromExcel} = bulkUpdateEmployeeFromExcelSlice.actions
